import { ApiClient } from "./ApiClient";

class AuthClient extends ApiClient {
  async register(data: Record<string, any>, type = "offering", token: string) {
    const response = await this.post(`/v2/auth/register/${type}`, data, {
      params: { token },
    });
    return response.data;
  }

  async mfa(data: Record<string, any>) {
    const response = await this.post("/v2/auth/mfa/email", data);
    return response.data;
  }

  async login(data: Record<string, any>) {
    const response = await this.post("/v2/auth/login", data);
    return response.data;
  }

  async loginIssuer(data: { email: string; password: string }): Promise<{
    channel: "SMS" | "EMAIL";
    destination: string;
    phoneRequired: boolean;
  }> {
    const response = await this.post("/v2/auth/login/issuer", data);
    return response.data;
  }

  async mfaSms(data: { email: string; mfa_code: string }) {
    const response = await this.post("/v2/auth/mfa/sms", data);
    return response.data;
  }

  async invitationLogin(data: Record<string, any>, inviteToken: string) {
    const response = await this.post("/v2/auth/invitation-login", data, {
      headers: { "x-invite-token": inviteToken },
    });
    return response.data;
  }

  async workflowRegister(data: Record<string, any>, offeringId: string) {
    const response = await this.post(`/v2/auth/workflow-register/${offeringId}`, data);
    return response;
  }

  async registrationContext(token: string): Promise<{ mode: "mfa" | "login"; destination: string }> {
    const response = await this.post(`/v2/auth/registration/${token}/context`);
    return response.data;
  }

  async registrationMfa(token: string): Promise<{ destination: string }> {
    const response = await this.post(`/v2/auth/registration/${token}/mfa`);
    return response.data;
  }

  async registrationLogin(token: string, password: string): Promise<{ destination: string }> {
    const response = await this.post(`/v2/auth/registration/${token}/login`, { password });
    return response.data;
  }

  async registrationVerify(token: string, mfa_code: string) {
    const response = await this.post(`/v2/auth/registration/${token}/verify`, { mfa_code });
    return response.data;
  }

  async registrationSetup(token: string, data: { password: string; password_confirmation: string; accept_tos: true }) {
    const response = await this.post(`/v2/auth/registration/${token}/setup`, data);
    return response.data;
  }

  async refreshToken(token: string): Promise<{
    accessToken: string;
    refreshToken: string;
  }> {
    const response = await this.post(`/v2/auth/refresh-token/`, {
      refresh_token: token,
    });
    return response.data;
  }
}

export default AuthClient;
